import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CategoriesService } from '../../../app/modules/admin/ecommerce/services/categories.service';
import { filter } from 'rxjs/operators';
import { Category } from '../../../app/core/models/category.model';

@Component({
  selector: 'app-back-navigation',
  templateUrl: './back-navigation.component.html',
  styleUrls: ['./back-navigation.component.scss']
})
export class BackNavigationComponent implements OnInit {
  isPosRoute: boolean;
  private categories: Category[];
  currentParams: any;
  private goBackUrl = '';

  constructor(
    private router: Router,
    private categoriesService: CategoriesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.categoriesService.getCategories().subscribe(categories => {
      this.categories = categories;

      // Handle the initial route manually
      this.handleNavigation(this.router.routerState.snapshot.url);
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.handleNavigation(event.urlAfterRedirects || event.url);
    });
  }

  goBack() {
    const url = this.router.url;

    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const paramMap = route.snapshot.paramMap;
    const posId = paramMap.get('posId');

    if (this.goBackUrl) {
      this.router.navigate([this.goBackUrl]);
    } else if (url.includes('pay')) {
      this.router.navigate([`./ecommerce/pos/${posId}`]);
    } else {
      this.router.navigate(['../']);
    }
  }

  private handleNavigation(url: string): void {
    this.goBackUrl = undefined;
    // Extract parameters for the current route
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const paramMap = route.snapshot.paramMap;

    this.currentParams = paramMap;
    const categoryId = paramMap.get('categoryId');
    const posId = paramMap.get('posId');

    const breadcrumbs = CategoriesService.buildBreadcrumb(this.categories, categoryId);

    if (categoryId) {
      const backProduct = breadcrumbs[breadcrumbs.length - 2];
      if (backProduct) {
        this.goBackUrl = `./ecommerce/pos/${posId}/${backProduct.id}`;
      } else {
        this.goBackUrl = `./ecommerce/pos/${posId}`;
      }
    } else if (posId && url.includes('ecommerce/pos')) {
      this.goBackUrl = `./ecommerce/pos/`;
    }

    // Set `isPosRoute` conditionally
    this.isPosRoute = url === '/ecommerce/pos';
  }
}
